<template>
  <v-dialog :value="open" @click:outside="closeDialog()" max-width="768">
    <v-card>
      <v-progress-linear v-if="isSubmitting" indeterminate color="primary" rounded height="6"></v-progress-linear>

      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Nueva Informacion de Cliente
          </v-card-title>
        </v-img>
      </v-card-title>

      <vuescroll
        :ops="{
          bar: { background: '#bacfcec0', keepShow: true },
        }"
      >
        <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
          <v-form>
            <v-card-title class="font-weight-medium primary--text">
              Información General del Cliente
            </v-card-title>
            <v-row dense>
              <!-- Nombre -->
              <v-col cols="12">
                <v-text-field
                  required
                  filled
                  rounded
                  class="rounded-small"
                  dense
                  label="Nombre del cliente"
                  name="client_name"
                  prepend-inner-icon="mdi-account"
                  type="text"
                  color="blue-grey"
                  v-model="payload.name"
                ></v-text-field>
              </v-col>
              <!-- Descripcion del cliente -->
              <v-col cols="12">
                <v-textarea
                  required
                  filled
                  rounded
                  class="rounded-small"
                  dense
                  label="Descripcion del cliente"
                  name="client_description"
                  prepend-inner-icon="mdi-account"
                  color="blue-grey"
                  v-model="payload.description"
                ></v-textarea>
              </v-col>
              <!-- Sector de la industria -->
              <v-col cols="12">
                <v-select
                  required
                  filled
                  rounded
                  dense
                  class="rounded-small"
                  label="Sector de la industria"
                  name="industry_sector"
                  prepend-inner-icon="mdi-account"
                  type="text"
                  color="blue-grey"
                  item-text="name"
                  item-value="id"
                  :items="[
                    { id: 1, name: 'Sector 1' },
                    { id: 2, name: 'Sector 2' },
                  ]"
                  v-model="payload.doc_sector_id"
                ></v-select>
              </v-col>
            </v-row>

            <v-card-title class="font-weight-medium primary--text">
              Servicio Contratado
            </v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-select
                  required
                  filled
                  rounded
                  dense
                  class="rounded-small"
                  label="Tipo de Servicio"
                  name="service_type"
                  prepend-inner-icon="mdi-account"
                  type="text"
                  color="blue-grey"
                  item-text="name"
                  item-value="id"
                  :items="serviceTypeList"
                  v-model="payload.doc_service_id"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Extensiones -->
            <extensions-section
              :extensionsArr="payload.extensions"
              @extension:change="(data) => handleChangeArrayFields('extensions', data)"
            ></extensions-section>

            <queues-section
              :queuesArr="payload.queues"
              @queue:change="(data) => handleChangeArrayFields('queues', data)"
            ></queues-section>

            <v-card-title class="font-weight-medium primary--text">
              Configuración de IVR de Ingreso
            </v-card-title>
            <v-row dense>
              <!-- Tiene IVR de ingreso -->
              <v-col cols="6">
                <v-row align="center">
                  <v-col cols="auto">
                    <v-card-text class="text-body-1">¿Tiene IVR de Ingreso?</v-card-text>
                  </v-col>
                  <v-col cols="auto">
                    <v-switch color="success" v-model="payload.has_ivr" inset></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="payload.has_ivr">
                <!-- ¿Tiene audio grabado? -->
                <v-fade-transition>
                  <v-col cols="6" v-if="payload.has_ivr">
                    <v-row align="center">
                      <v-col cols="auto">
                        <v-card-text class="text-body-1">¿Tiene audio grabado?</v-card-text>
                      </v-col>
                      <v-col cols="auto">
                        <v-switch color="success" v-model="payload.ivr_audio" inset></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-fade-transition>

                <!-- Mensaje de audio -->
                <v-fade-transition>
                  <v-col cols="12" v-if="!payload.has_ivr_audio">
                    <v-textarea
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      label="Mensaje de audio"
                      name="extensions_quantity"
                      prepend-inner-icon="mdi-text"
                      color="blue-grey"
                      v-model="payload.ivr_text"
                    ></v-textarea>
                  </v-col>
                </v-fade-transition>

                <!-- Archivo de audio -->
                <v-fade-transition>
                  <v-col cols="12" v-if="has_ivr_audio">
                    <v-file-input
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      label="Archivo de audio"
                      prepend-icon=""
                      prepend-inner-icon="mdi-paperclip"
                      truncate-length="15"
                      v-model="payload.ivr_audio_file"
                    ></v-file-input>
                  </v-col>
                </v-fade-transition>
              </template>
            </v-row>
            <template v-if="false">
              <v-card-title class="font-weight-medium primary--text">
                Horarios de Atención
              </v-card-title>
              <v-row dense>
                <!-- Tiene Horario de atencion= -->
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-card-text class="text-body-1">¿Tiene horario de atención? </v-card-text>
                    </v-col>
                    <v-col cols="auto">
                      <v-switch color="success" v-model="payload.schedule.has_schedule" inset></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- ¿Tiene audio grabado? -->
                <v-fade-transition>
                  <v-col cols="12" v-if="payload.schedule.has_schedule">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Horario"
                      name="extensions_quantity"
                      prepend-inner-icon="mdi-clock-outline"
                      color="blue-grey"
                      v-model="payload.schedule.schedule"
                    ></v-text-field>
                  </v-col>
                </v-fade-transition>
              </v-row>
            </template>

            <v-card-title class="font-weight-medium primary--text">
              Mensaje Fuera de Horario
            </v-card-title>
            <v-row dense>
              <!-- Tiene mensaje de fuera de horario -->
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="auto">
                    <v-card-text class="text-body-1">¿Tiene mensaje de fuera de horario?</v-card-text>
                  </v-col>
                  <v-col cols="auto">
                    <v-switch color="success" v-model="payload.has_off_hours_message" inset></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="payload.has_off_hours_message">
                <!-- ¿Tiene audio grabado? -->
                <v-fade-transition>
                  <v-col cols="12" v-if="payload.has_off_hours_message">
                    <v-row align="center">
                      <v-col cols="auto">
                        <v-card-text class="text-body-1">¿Tiene audio grabado?</v-card-text>
                      </v-col>
                      <v-col cols="auto">
                        <v-switch color="success" v-model="payload.off_hours_audio" inset></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-fade-transition>

                <!-- Mensaje de audio -->
                <v-fade-transition>
                  <v-col cols="12" v-if="!payload.off_hours_audio">
                    <v-textarea
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      label="Mensaje de audio"
                      name="extensions_quantity"
                      prepend-inner-icon="mdi-text"
                      color="blue-grey"
                      v-model="payload.off_hours_text"
                    ></v-textarea>
                  </v-col>
                </v-fade-transition>

                <!-- Archivo de audio -->
                <v-fade-transition>
                  <v-col cols="12" v-if="payload.off_hours_audio">
                    <v-file-input
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      label="Archivo de audio"
                      prepend-icon=""
                      prepend-inner-icon="mdi-paperclip"
                      truncate-length="15"
                      v-model="payload.off_hours_audio_file"
                    ></v-file-input>
                  </v-col>
                </v-fade-transition>
              </template>
            </v-row>

            <!-- Agentes -->
            <agents-section
              :agentsArr="payload.agents"
              @agent:change="(data) => handleChangeArrayFields('agents', data)"
            ></agents-section>

            <v-card-title class="font-weight-medium primary--text">
              Configuración de Pausas
            </v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="auto">
                    <v-card-text class="text-body-1">¿Utilizará pausas?</v-card-text>
                  </v-col>
                  <v-col cols="auto">
                    <v-switch color="success" v-model="payload.uses_breaks" inset></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-fade-transition>
                <v-col cols="12" v-if="payload.uses_breaks">
                  <v-textarea
                    required
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Pausas permitidas"
                    name="extensions_quantity"
                    prepend-inner-icon="mdi-coffee"
                    color="blue-grey"
                    v-model="payload.breaks_description"
                  ></v-textarea>
                </v-col>
              </v-fade-transition>
            </v-row>

            <v-card-title class="font-weight-medium primary--text">
              Configuración de WhatsApp
            </v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  required
                  filled
                  rounded
                  class="rounded-small"
                  dense
                  label="Cantidad de Agentes de WhatsApp"
                  name="extensions_quantity"
                  prepend-inner-icon="mdi-whatsapp"
                  color="blue-grey"
                  v-model="payload.whatsapp.whatsapp_agents"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="auto">
                    <v-card-text class="text-body-1">¿Utilizará Bot de WhatsApp?</v-card-text>
                  </v-col>
                  <v-col cols="auto">
                    <v-switch color="success" v-model="payload.whatsapp.uses_bot" inset></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="payload.whatsapp.uses_bot">
                <v-col cols="12">
                  <v-textarea
                    required
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Horario de atención del bot"
                    name="extensions_quantity"
                    prepend-inner-icon="mdi-clock-outline"
                    color="blue-grey"
                    v-model="payload.whatsapp.bot_schedule"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    required
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Flujo de respuestas predefinidas"
                    name="extensions_quantity"
                    prepend-inner-icon="mdi-chat-outline"
                    color="blue-grey"
                    v-model="payload.whatsapp.bot_flow"
                  ></v-textarea>
                </v-col>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
      </vuescroll>

      <v-divider></v-divider>

      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            :disabled="isSubmitting"
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closeDialog()"
            >Cancelar</v-btn
          >
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            rounded
            :loading="isSubmitting"
            color="success"
            :class="hover ? 'shadow-2' : 'shadow-4'"
            class="px-8"
            @click="handleSubmit"
          >
            {{ dataToEdit ? "Actualizar" : "Añadir" }}
          </v-btn>
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";

import { DIALOG_MAX_HEIGHT } from "@/utils";
import { serviceTypeList, defaultValue } from "./utils";
import { PbxHttpClient } from "@/services";
import { ExtensionsSection, AgentsSection, QueuesSection } from "./formSections";

export default {
  components: {
    vuescroll,
    ExtensionsSection,
    AgentsSection,
    QueuesSection,
  },
  props: {
    open: {
      type: Boolean,
    },
    dataToEdit: {
      type: Object,
    },
  },
  data() {
    return {
      DIALOG_MAX_HEIGHT,
      serviceTypeList,
      isSubmitting: false,
      payload: { ...JSON.parse(JSON.stringify(defaultValue)) },
      has_ivr_audio: false,
      off_hours_has_audio: false,
      use_whatsapp: false,
    };
  },

  watch: {
    open(val) {
      if (val) {
        if (Object.keys(this.dataToEdit).length)
          this.payload = {
            ...JSON.parse(JSON.stringify(this.dataToEdit)),
            whatsapp_config: undefined,
            whatsapp: this.dataToEdit.whatsapp_config,
          };
        else this.payload = { ...JSON.parse(JSON.stringify(defaultValue)) };
      }
    },
  },

  methods: {
    closeDialog(data) {
      this.$emit("dialog:close", data);
    },
    /**
     * Update the payload object attribute with the array given
     *
     * This array is using a autogenerated ID that must be removed in create
     * process
     *
     * @param field {String} name of the field of payload to be updated
     * @param newArr {Array} updated array
     *
     */
    handleChangeArrayFields(field, newArr) {
      if (this.payload[field]) this.payload[field] = newArr;
    },
    async handleSubmit() {
      this.isSubmitting = true;
      try {
        let res;
        if (this.dataToEdit) {
          const alreadyExistAgentsIds = this.dataToEdit.agents.reduce((acc, el) => ({ ...acc, [el.id]: true }));
          const alreadyExistQueuesIds = this.dataToEdit.queues.reduce((acc, el) => ({ ...acc, [el.id]: true }));
          const alreadyExistExtensionIds = this.dataToEdit.extensions.reduce((acc, el) => ({ ...acc, [el.id]: true }));

          const payload = {
            ...this.payload,
            agents: this.payload.agents.map(({ id, ...el }) => (alreadyExistAgentsIds[id] ? { ...el, id } : el)),
            queues: this.queues.agents.map(({ id, ...el }) => (alreadyExistQueuesIds[id] ? { ...el, id } : el)),
            extensions: this.extensions.agents.map(({ id, ...el }) =>
              alreadyExistExtensionIds[id] ? { ...el, id } : el,
            ),
            extensions_count: this.payload.extensions.length,
            agents_count: this.payload.agents.length,
            whatsapp_agents_count: this.whatsapp.agents,
          };

          res = await PbxHttpClient.put(`/doc-clients/${this.dataToEdit.id}`, payload);
          this.$snotify.success("Cliente actualizado con éxito.", "¡Hecho!");
        } else {
          const payload = {
            ...this.payload,
            // eslint-disable-next-line no-unused-vars
            agents: this.payload.agents.map(({ id, ...el }) => el),
            // eslint-disable-next-line no-unused-vars
            queues: this.queues.agents.map(({ id, ...el }) => el),
            // eslint-disable-next-line no-unused-vars
            extensions: this.extensions.agents.map(({ id, ...el }) => el),
            extensions_count: this.payload.extensions.length,
            agents_count: this.payload.agents.length,
            whatsapp_agents_count: this.whatsapp.agents,
          };
          res = await PbxHttpClient.post("/doc-clients", payload);
          this.$snotify.success("Cliente creado con éxito.", "¡Hecho!");
        }
        this.closeDialog({ ...res.data.data });
      } catch (error) {
        this.$snotify.error("Hubo un error guardando el cliente", "¡Error!");
      }

      this.isSubmitting = false;
    },
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
  appearance: textfield; /* Firefox */
}
</style>
